// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SearchResults":"js_a bhj_a bhj_j bhj_q bhj_rp bhj_rq bhj_w"};